// extracted by mini-css-extract-plugin
export default {"button":"NextButton_button__t5t6N","circle":"NextButton_circle__JFIWo","arrow":"NextButton_arrow__H7EfR","title":"NextButton_title__IWh+p","icon":"NextButton_icon__RxLN2"};